import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { getDefaultChoices } from "./Utils";
import FocusTrap from "./FocusTrap";
import Cookies from "./Cookies";

const createMarkup = string => {
  return { __html: string };
};

function OptInDialog(props) {
  const { config, initial, onClose } = props;
  const page = "config";
  // const [page, setPage] = useState(initial ? "front" : "config");
  const [saving, isSaving] = useState(false);
  const dialogElement = useRef();

  const cookieConfig = { ...config.cookieConfig };

  // const [choices, setChoices] = useState(getDefaultChoices(config.choices));

  const saveCookie = useCallback(cookiename => {
    Cookies.set({ ...cookieConfig, name: cookiename, value: "accepted" });
  }, [cookieConfig]);

  const deleteCookie = useCallback(cookiename => {
    Cookies.delete({ ...cookieConfig, name: cookiename });
  }, [cookieConfig]);

  const saveData = useCallback(data => {
    Cookies.set({ ...cookieConfig, value: encodeURIComponent(JSON.stringify(data)) });
  }, [cookieConfig]);

  const readData = () => {
    let readByCookie = Cookies.get(config.cookieConfig.name);
    if (readByCookie === "") {
      return { cookie: false, choices: getDefaultChoices(config.choices) };
    } else {
      return { cookie: true, choices: JSON.parse(decodeURIComponent(readByCookie)) };
    }
  };

  const handleAdditionalCookies = useCallback(selected => {
    Object.keys(selected).forEach(item => {
      Boolean(selected[item]) ? saveCookie(`${item}_consent`) : deleteCookie(`${item}_consent`);
    });
  }, [saveCookie, deleteCookie]);

  const saveConfig = (all = false) => {
    let selected = {};
    if (all) {
      Object.keys(choices).forEach(item => {
        selected[item] = true;
      });
    } else {
      let checks = dialogElement.current.querySelectorAll(".choices .choice input");
      checks.forEach(item => {
        selected[item.name] = Boolean(item.checked);
      });
    }
    isSaving(true);
    setChoices(selected);
  };

  const [choices, setChoices] = useState(readData().choices);

  useEffect(() => {
    // const focusTrap = new FocusTrap(dialogElement.current).snap();
    new FocusTrap(dialogElement.current);
  }, [page]);

  const saveChoices = useCallback(() => {
    isSaving(false);
    saveData(choices);
    handleAdditionalCookies(choices);
    onClose();
  }, [choices, handleAdditionalCookies, saveData, onClose]);

  useEffect(() => {
    if (saving) {
      saveChoices();
    }
  }, [saving, saveChoices]);

  const Button = props => {
    return (
      <button className={props.className} onClick={props.onClick}>
        {props.children}
      </button>
    );
  };

  if (initial && readData().cookie) onClose();

  return (
    <div ref={dialogElement} className="dialog">
      <header>{config.heading}</header>
      {choices && (
        <>
          <section className="content">
            <p className="info" dangerouslySetInnerHTML={createMarkup(config.text[page])}></p>
            {page === "config" && (
              <>
                <div className="choices">
                  {Object.keys(choices).map((item, index) => (
                    <div key={`${index}-${item}`} className="choice">
                      <label className="switch">
                        <input name={item} type="checkbox" defaultChecked={Boolean(choices[item]) ? "defaultChecked" : null} disabled={Boolean(config.choices[item].unchangeable)} />
                        <span className="slider round"></span>
                        <span className="labelText">{config.choices[item].label}</span>
                      </label>
                      <p>{config.choices[item].description}</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </section>
          <footer>
            <div className="buttons">
              {/* <Button
                className="btn outline"
                onClick={e => {
                  page === "front" ? setPage("config") : saveConfig();
                }}>
                {page === "front" ? config.labels.showConfig : config.labels.saveConfig}
              </Button> */}
              <Button
                className="btn"
                onClick={e => {
                  saveConfig(true);
                }}>
                {config.labels.acceptAll}
              </Button>
            </div>
          </footer>
        </>
      )}
    </div>
  );
}

let OptIn = function (data = {}, initial = true) {
  let el = document.createElement("div");
  el.id = data.cookieConfig?.name || "optIn";
  document.body.insertBefore(el, document.body.firstChild);

  let props = { config: data, initial: initial };

  const bodyStyles = Boolean(document.body.getAttribute("style"))
    ? document.body
        .getAttribute("style")
        .split(";")
        .filter(item => Boolean(item))
    : [];

  const injectScrollStop = () => {
    if (data.bodyScrollStop) {
      let bStyles = data.bodyScrollStop.concat(bodyStyles);
      return document.body.setAttribute("style", `${bStyles.join(";")};`);
    }
  };
  const removeScrollStop = () => {
    if (data.bodyScrollStop) {
      if (bodyStyles.length) return document.body.setAttribute("style", `${bodyStyles.join(";")};`);
      else return document.body.removeAttribute("style");
    }
  };

  const onClose = () => {
    removeScrollStop();
    el.remove();
    OptIn = null;
  };

  injectScrollStop();
  ReactDOM.render(<OptInDialog {...props} onClose={onClose} />, el);
};

window.__MRM_OPTIN = OptIn;
export default OptIn;
